import React, { ReactNode } from 'react'

import VStack from 'src/govwell-ui/components/Flex/VStack'
import Text from 'src/govwell-ui/components/Text/Text'

type TooltipValue = {
  id: string
  value: string | ReactNode
}

type Props = {
  tooltips: TooltipValue[]
}

const ChartTooltip = ({ tooltips }: Props) => {
  return (
    <div className="w-max max-w-[225px] rounded-md border border-gray-300 bg-white p-2">
      <VStack>
        {tooltips.map((tooltip) => (
          <Text.Label key={tooltip.id}>{tooltip.value}</Text.Label>
        ))}
      </VStack>
    </div>
  )
}

export default React.memo(ChartTooltip)
